import { useState, useEffect, type FC } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import IconNew from "../../../assets/TakyonDesignSystem/components/Icon/Icon";
import { closeModal } from "../../../assets/Utils/modal";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from "../../components/Carousel/Carousel";

import ImageWithFallback from "../../components/ImageWithFallback/ImageWithFallback";

type FullScreenCarouselProps = {
  startIndex: number;
  totalImagesCount: number;
  imageUrls: string[];
  hotelId: string;
  hotelName: string;
};

export const FullScreenCarousel: FC<FullScreenCarouselProps> = ({
  startIndex,
  totalImagesCount,
  imageUrls,
  hotelId,
  hotelName,
}) => {
  const [carouselFullScreenApi, setCarouselFullScreenApi] =
    useState<CarouselApi>();
  const [carouselFullScreenCurrentSlide, setCarouselFullScreenCurrentSlide] =
    useState<number | undefined>();
  const [carouselFullScreenSlidesCount, setCarouselFullScreenSlidesCount] =
    useState(totalImagesCount);

  useEffect(() => {
    if (!carouselFullScreenApi) {
      return;
    }
    const updateCarouselFullScreenState = () => {
      setCarouselFullScreenCurrentSlide(
        carouselFullScreenApi.selectedScrollSnap(),
      );
      setCarouselFullScreenSlidesCount(
        carouselFullScreenApi.scrollSnapList().length,
      );
    };

    updateCarouselFullScreenState();

    carouselFullScreenApi.on("select", updateCarouselFullScreenState);

    return () => {
      carouselFullScreenApi.off("select", updateCarouselFullScreenState);
    };
  }, [carouselFullScreenApi]);

  return (
    <div className="flex flex-col h-full">
      <header className="flex justify-end px-3 items-center box-border h-12">
        <button
          type="button"
          onClick={closeModal}
          className="bg-transparent border-none touch-hitbox relative"
        >
          <IconNew icon="close" className="size-5 fill-white" />
        </button>
      </header>
      <main className="relative h-full overflow-hidden">
        <Carousel
          setApi={setCarouselFullScreenApi}
          opts={{
            startIndex,
          }}
          className="size-full [&>div]:size-full"
        >
          <CarouselContent className="size-full">
            {imageUrls.map((url, index) => (
              <CarouselItem
                key={`gallery-img-${index}-${hotelId}`}
                className="size-full flex items-center md:justify-center"
              >
                <ImageWithFallback
                  src={url.replace("square60", "square600")}
                  alt={`${hotelName} - ${index + 1}`}
                  className="md:h-full w-screen md:w-full object-cover md:object-contain bg-black aspect-[1/0.8]"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-4" />
          <CarouselNext className="right-4" />
        </Carousel>
      </main>
      <footer className="flex justify-end px-3 items-center box-border h-12">
        <span className="text-xs font-medium text-white">{`${
          (carouselFullScreenCurrentSlide ?? startIndex) + 1
        } / ${carouselFullScreenSlidesCount}`}</span>
      </footer>
    </div>
  );
};
